// Google Analytics 유틸리티

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
    dataLayer?: any[];
  }
}

// 로컬 환경 체크 (내부 헬퍼)
const isLocalhost = () => {
  return typeof window !== 'undefined' && 
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
};

// GA 초기화 여부 확인 (내부 헬퍼)
const isGAInitialized = () => {
  if (isLocalhost()) return false;
  return typeof window !== 'undefined' && typeof window.gtag === 'function';
};

// 페이지뷰 추적 (내부 함수)
const trackPageView = (url: string) => {
  if (isGAInitialized()) {
    window.gtag!('config', 'G-R6FB0C7JDE', {
      page_path: url,
    });
  }
};

// 이벤트 추적 (내부 함수)
const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  if (isGAInitialized()) {
    window.gtag!('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

/**
 * Analytics Service
 * 모든 분석 이벤트는 이 객체를 통해서만 접근
 * 
 * @example
 * import { analytics } from '@/utils/analytics';
 * analytics.trackEvent('click', 'Button', 'Submit');
 * analytics.trackLabApplication('React Lab', 50000);
 */
export const analytics = {
  /**
   * 페이지뷰 추적
   */
  trackPageView,

  /**
   * 일반 이벤트 추적
   */
  trackEvent,

  /**
   * 클럽 신청 이벤트
   */
  trackClubApplication: (clubTitle: string, price?: number) => {
    trackEvent('apply', 'Club', clubTitle, price);
  },

  /**
   * 결제 완료 이벤트
   */
  trackPayment: (clubTitle: string, amount: number) => {
    trackEvent('payment', 'Purchase', clubTitle, amount);
  },

  /**
   * 클럽 상세 조회 이벤트
   */
  trackClubView: (clubTitle: string) => {
    trackEvent('view', 'Club', clubTitle);
  },

  /**
   * 피드 작성 이벤트
   */
  trackFeedPost: () => {
    trackEvent('post', 'Feed');
  },

  /**
   * 로그인 이벤트
   */
  trackLogin: (method: string) => {
    trackEvent('login', 'Auth', method);
  },

  /**
   * 회원가입 이벤트
   */
  trackSignup: (method: string) => {
    trackEvent('signup', 'Auth', method);
  },

  /**
   * 검색 이벤트
   */
  trackSearch: (query: string) => {
    trackEvent('search', 'Search', query);
  },

  /**
   * 에러 이벤트
   */
  trackError: (errorMessage: string) => {
    trackEvent('error', 'Error', errorMessage);
  },
} as const;
